import * as Dtos from "../dtos/Tmd.dtos";
import {  IFormFilter } from "../reducers/index";

export const
    LoadTrialInstitutionItemTemplateCategory: ITrialInstitutionItemTemplateCategoryLoadActionCreator = () => {
        return {
            type: ACTION_TRIALINSTITUTIONITEMTEMPLATECATEGORIES_LOAD
        }
    },
    LoadTrialInstitutionItemTemplateCategoryById: ITrialInstitutionItemTemplateCategoryLoadByIdActionCreator = (id) => {
        return {
            type: ACTION_TRIALINSTITUTIONITEMTEMPLATECATEGORIES_LOAD_BY_ID,
            id
        }
    },
    LoadSuccess: ITrialInstitutionItemTemplateCategoryLoadSuccessActionCreator = (formData, formState, formProperties, lookups, responseStatus) => {
        return {
            type: ACTION_TRIALINSTITUTIONITEMTEMPLATECATEGORIES_LOAD_SUCCESS,
            formData,
            formState,
            formProperties,
            lookups,
            responseStatus
        }
    },
    LoadFailure: ITrialInstitutionItemTemplateCategoryLoadFailureActionCreator = (responseStatus) => {
        return {
            type: ACTION_TRIALINSTITUTIONITEMTEMPLATECATEGORIES_LOAD_FAILURE,
            responseStatus
        }
    },

    SaveTrialInstitutionItemTemplateCategory: ITrialInstitutionItemTemplateCategorySaveActionCreator = (formData) => {
        return {
            type: ACTION_TRIALINSTITUTIONITEMTEMPLATECATEGORIES_SAVE,
            formData
        }
    },
    SaveSuccess: ITrialInstitutionItemTemplateCategorySaveSuccessActionCreator = (formData, formState, responseStatus) => {
        return {
            type: ACTION_TRIALINSTITUTIONITEMTEMPLATECATEGORIES_SAVE_SUCCESS,
            formData,
            formState,
            responseStatus
        }
    },
    SaveFailure: ITrialInstitutionItemTemplateCategorySaveFailureActionCreator = (responseStatus) => {
        return {
            type: ACTION_TRIALINSTITUTIONITEMTEMPLATECATEGORIES_SAVE_FAILURE,
            responseStatus
        }
    },

    CreateTrialInstitutionItemTemplateCategory: ITrialInstitutionItemTemplateCategoryCreateActionCreator = () => {

        return {
            type: ACTION_TRIALINSTITUTIONITEMTEMPLATECATEGORIES_CREATE
        }
    },
    CreateSuccess: ITrialInstitutionItemTemplateCategoryCreateSuccessActionCreator = (formData, formState, formProperties, lookups) => {
        return {
            type: ACTION_TRIALINSTITUTIONITEMTEMPLATECATEGORIES_CREATE_SUCCESS,
            formData,
            formState,
            formProperties,
            lookups
        }
    },
    CreateFailure: ITrialInstitutionItemTemplateCategoryCreateFailureActionCreator = (responseStatus) => {
        return {
            type: ACTION_TRIALINSTITUTIONITEMTEMPLATECATEGORIES_CREATE_FAILURE,
            responseStatus
        }
    },

    ValidateTrialInstitutionItemTemplateCategory: ITrialInstitutionItemTemplateCategoryValidateActionCreator = (formData) => {
        return {
            type: ACTION_TRIALINSTITUTIONITEMTEMPLATECATEGORIES_VALIDATE,
            formData
        }
    },
    ValidateSuccess: ITrialInstitutionItemTemplateCategoryValidateSuccessActionCreator = (formData, formState, responseStatus) => {
        return {
            type: ACTION_TRIALINSTITUTIONITEMTEMPLATECATEGORIES_VALIDATE_SUCCESS,
            formData,
            formState,
            responseStatus
        }
    },
    ValidateFailure: ITrialInstitutionItemTemplateCategoryValidateFailureActionCreator = (responseStatus) => {
        return {
            type: ACTION_TRIALINSTITUTIONITEMTEMPLATECATEGORIES_VALIDATE_FAILURE,
            responseStatus
        }
    },

    Clear: ITrialInstitutionItemTemplateCategoryClearActionCreator = (propertiesToClear?) => {
        return {
            type: ACTION_TRIALINSTITUTIONITEMTEMPLATECATEGORIES_CLEAR,
            propertiesToClear
        }
    },
    Filter: ITrialInstitutionItemTemplateCategoryFilterActionCreator = (formFilter) => {
        return {
            type: ACTION_TRIALINSTITUTIONITEMTEMPLATECATEGORIES_FILTER,
            formFilter
        }
    };



export const
    ACTION_TRIALINSTITUTIONITEMTEMPLATECATEGORIES_LOAD = "ACTION_TRIALINSTITUTIONITEMTEMPLATECATEGORIES_LOAD",
    ACTION_TRIALINSTITUTIONITEMTEMPLATECATEGORIES_LOAD_BY_ID = "ACTION_TRIALINSTITUTIONITEMTEMPLATECATEGORIES_LOAD_BY_ID",
    ACTION_TRIALINSTITUTIONITEMTEMPLATECATEGORIES_LOAD_SUCCESS = "ACTION_TRIALINSTITUTIONITEMTEMPLATECATEGORIES_LOAD_SUCCESS",
    ACTION_TRIALINSTITUTIONITEMTEMPLATECATEGORIES_LOAD_FAILURE = "ACTION_TRIALINSTITUTIONITEMTEMPLATECATEGORIES_LOAD_FAILURE",

    ACTION_TRIALINSTITUTIONITEMTEMPLATECATEGORIES_SAVE = "ACTION_TRIALINSTITUTIONITEMTEMPLATECATEGORIES_SAVE",
    ACTION_TRIALINSTITUTIONITEMTEMPLATECATEGORIES_SAVE_SUCCESS = "ACTION_TRIALINSTITUTIONITEMTEMPLATECATEGORIES_SAVE_SUCCESS",
    ACTION_TRIALINSTITUTIONITEMTEMPLATECATEGORIES_SAVE_FAILURE = "ACTION_TRIALINSTITUTIONITEMTEMPLATECATEGORIES_SAVE_FAILURE",

    ACTION_TRIALINSTITUTIONITEMTEMPLATECATEGORIES_CREATE = "ACTION_TRIALINSTITUTIONITEMTEMPLATECATEGORIES_CREATE",
    ACTION_TRIALINSTITUTIONITEMTEMPLATECATEGORIES_CREATE_SUCCESS = "ACTION_TRIALINSTITUTIONITEMTEMPLATECATEGORIES_CREATE_SUCCESS",
    ACTION_TRIALINSTITUTIONITEMTEMPLATECATEGORIES_CREATE_FAILURE = "ACTION_TRIALINSTITUTIONITEMTEMPLATECATEGORIES_CREATE_FAILURE",

    ACTION_TRIALINSTITUTIONITEMTEMPLATECATEGORIES_VALIDATE = "ACTION_TRIALINSTITUTIONITEMTEMPLATECATEGORIES_VALIDATE",
    ACTION_TRIALINSTITUTIONITEMTEMPLATECATEGORIES_VALIDATE_SUCCESS = "ACTION_TRIALINSTITUTIONITEMTEMPLATECATEGORIES_VALIDATE_SUCCESS",
    ACTION_TRIALINSTITUTIONITEMTEMPLATECATEGORIES_VALIDATE_FAILURE = "ACTION_TRIALINSTITUTIONITEMTEMPLATECATEGORIES_VALIDATE_FAILURE",

    ACTION_TRIALINSTITUTIONITEMTEMPLATECATEGORIES_CLEAR = "ACTION_TRIALINSTITUTIONITEMTEMPLATECATEGORIES_CLEAR",

    ACTION_TRIALINSTITUTIONITEMTEMPLATECATEGORIES_FILTER = "ACTION_TRIALINSTITUTIONITEMTEMPLATECATEGORIES_FILTER";

export interface ITrialInstitutionItemTemplateCategoryLoadAction {
    type: "ACTION_TRIALINSTITUTIONITEMTEMPLATECATEGORIES_LOAD";
}

export interface ITrialInstitutionItemTemplateCategoryLoadActionCreator {
    (): ITrialInstitutionItemTemplateCategoryLoadAction;
}

export interface ITrialInstitutionItemTemplateCategoryLoadSuccessAction {
    type: "ACTION_TRIALINSTITUTIONITEMTEMPLATECATEGORIES_LOAD_SUCCESS";
    formData: Dtos.TrialInstitutionItemTemplateCategory | Dtos.TrialInstitutionItemTemplateCategory[];
    formState: Dtos.FormState;
    formProperties: Dtos.FormProperty[];
    lookups: Dtos.Lookup[];
    responseStatus: Dtos.ResponseStatus;
}

export interface ITrialInstitutionItemTemplateCategoryLoadSuccessActionCreator {
    (
        formData: Dtos.TrialInstitutionItemTemplateCategory | Dtos.TrialInstitutionItemTemplateCategory[],
        formState: Dtos.FormState,
        formProperties: Dtos.FormProperty[],
        lookups: Dtos.Lookup[],
        responseStatus: Dtos.ResponseStatus
    ): ITrialInstitutionItemTemplateCategoryLoadSuccessAction;
}

export interface ITrialInstitutionItemTemplateCategoryLoadFailureAction {
    type: "ACTION_TRIALINSTITUTIONITEMTEMPLATECATEGORIES_LOAD_FAILURE";
    responseStatus: Dtos.ResponseStatus;
}

export interface ITrialInstitutionItemTemplateCategoryLoadFailureActionCreator {
    (responseStatus: Dtos.ResponseStatus): ITrialInstitutionItemTemplateCategoryLoadFailureAction;
}

export interface ITrialInstitutionItemTemplateCategoryLoadByIdAction {
    type: "ACTION_TRIALINSTITUTIONITEMTEMPLATECATEGORIES_LOAD_BY_ID";
    id: number;
}

export interface ITrialInstitutionItemTemplateCategoryLoadByIdActionCreator {
    (id: number): ITrialInstitutionItemTemplateCategoryLoadByIdAction;
}


export interface ITrialInstitutionItemTemplateCategorySaveAction {
    type: "ACTION_TRIALINSTITUTIONITEMTEMPLATECATEGORIES_SAVE";
    formData: Dtos.TrialInstitutionItemTemplateCategory;

}

export interface ITrialInstitutionItemTemplateCategorySaveActionCreator {
    (
        formData: Dtos.TrialInstitutionItemTemplateCategory
    ): ITrialInstitutionItemTemplateCategorySaveAction;
}

export interface ITrialInstitutionItemTemplateCategorySaveSuccessAction {
    type: "ACTION_TRIALINSTITUTIONITEMTEMPLATECATEGORIES_SAVE_SUCCESS";
    formData: Dtos.TrialInstitutionItemTemplateCategory;
    formState: Dtos.FormState,
    responseStatus: Dtos.ResponseStatus;
}

export interface ITrialInstitutionItemTemplateCategorySaveSuccessActionCreator {
    (
        formData: Dtos.TrialInstitutionItemTemplateCategory,
        formState: Dtos.FormState,
        responseStatus: Dtos.ResponseStatus
    ): ITrialInstitutionItemTemplateCategorySaveSuccessAction;
}

export interface ITrialInstitutionItemTemplateCategorySaveFailureAction {
    type: "ACTION_TRIALINSTITUTIONITEMTEMPLATECATEGORIES_SAVE_FAILURE";
    responseStatus: Dtos.ResponseStatus
}

export interface ITrialInstitutionItemTemplateCategorySaveFailureActionCreator {
    (responseStatus: Dtos.ResponseStatus): ITrialInstitutionItemTemplateCategorySaveFailureAction;
}

export interface ITrialInstitutionItemTemplateCategoryCreateAction {
    type: "ACTION_TRIALINSTITUTIONITEMTEMPLATECATEGORIES_CREATE"
}

export interface ITrialInstitutionItemTemplateCategoryCreateActionCreator {
    (): ITrialInstitutionItemTemplateCategoryCreateAction
}

export interface ITrialInstitutionItemTemplateCategoryCreateSuccessAction {
    type: "ACTION_TRIALINSTITUTIONITEMTEMPLATECATEGORIES_CREATE_SUCCESS";
    formData: Dtos.TrialInstitutionItemTemplateCategory;
    formState: Dtos.FormState;
    formProperties: Dtos.FormProperty[];
    lookups: Dtos.Lookup[];
}

export interface ITrialInstitutionItemTemplateCategoryCreateSuccessActionCreator {
    (
        formData: Dtos.TrialInstitutionItemTemplateCategory,
        formState: Dtos.FormState,
        formProperties: Dtos.FormProperty[],
        lookups: Dtos.Lookup[]
    ): ITrialInstitutionItemTemplateCategoryCreateSuccessAction;
}

export interface ITrialInstitutionItemTemplateCategoryCreateFailureAction {
    type: "ACTION_TRIALINSTITUTIONITEMTEMPLATECATEGORIES_CREATE_FAILURE";
    responseStatus: Dtos.ResponseStatus
}

export interface ITrialInstitutionItemTemplateCategoryCreateFailureActionCreator {
    (responseStatus: Dtos.ResponseStatus): ITrialInstitutionItemTemplateCategoryCreateFailureAction;
}

export interface ITrialInstitutionItemTemplateCategoryValidateAction {
    type: "ACTION_TRIALINSTITUTIONITEMTEMPLATECATEGORIES_VALIDATE";
    formData: Dtos.TrialInstitutionItemTemplateCategory;

}

export interface ITrialInstitutionItemTemplateCategoryValidateActionCreator {
    (
        formData: Dtos.TrialInstitutionItemTemplateCategory
    ): ITrialInstitutionItemTemplateCategoryValidateAction;
}

export interface ITrialInstitutionItemTemplateCategoryValidateSuccessAction {
    type: "ACTION_TRIALINSTITUTIONITEMTEMPLATECATEGORIES_VALIDATE_SUCCESS";
    formData: Dtos.TrialInstitutionItemTemplateCategory;
    formState: Dtos.FormState,
    responseStatus: Dtos.ResponseStatus;
}

export interface ITrialInstitutionItemTemplateCategoryValidateSuccessActionCreator {
    (
        formData: Dtos.TrialInstitutionItemTemplateCategory,
        formState: Dtos.FormState,
        responseStatus: Dtos.ResponseStatus
    ): ITrialInstitutionItemTemplateCategoryValidateSuccessAction;
}

export interface ITrialInstitutionItemTemplateCategoryValidateFailureAction {
    type: "ACTION_TRIALINSTITUTIONITEMTEMPLATECATEGORIES_VALIDATE_FAILURE";
    responseStatus: Dtos.ResponseStatus
}

export interface ITrialInstitutionItemTemplateCategoryValidateFailureActionCreator {
    (responseStatus: Dtos.ResponseStatus): ITrialInstitutionItemTemplateCategoryValidateFailureAction;
}

export interface ITrialInstitutionItemTemplateCategoryClearAction {
    type: "ACTION_TRIALINSTITUTIONITEMTEMPLATECATEGORIES_CLEAR";
    propertiesToClear?: string[];
}

export interface ITrialInstitutionItemTemplateCategoryClearActionCreator {
    (propertiesToClear?: string[]): ITrialInstitutionItemTemplateCategoryClearAction;
}

export interface ITrialInstitutionItemTemplateCategoryFilterActionCreator {
    (formFilter: IFormFilter): ITrialInstitutionItemTemplateCategoryFilterAction;
}

export interface ITrialInstitutionItemTemplateCategoryFilterAction {
    type: "ACTION_TRIALINSTITUTIONITEMTEMPLATECATEGORIES_FILTER";
    formFilter: IFormFilter;
}

export type TrialInstitutionItemTemplateCategoryAction =
    ITrialInstitutionItemTemplateCategoryLoadAction |
    ITrialInstitutionItemTemplateCategoryLoadByIdAction |
    ITrialInstitutionItemTemplateCategoryLoadFailureAction |
    ITrialInstitutionItemTemplateCategoryLoadSuccessAction |
    ITrialInstitutionItemTemplateCategorySaveAction |
    ITrialInstitutionItemTemplateCategorySaveSuccessAction |
    ITrialInstitutionItemTemplateCategorySaveFailureAction |
    ITrialInstitutionItemTemplateCategoryCreateAction |
    ITrialInstitutionItemTemplateCategoryCreateSuccessAction |
    ITrialInstitutionItemTemplateCategoryCreateFailureAction |
    ITrialInstitutionItemTemplateCategoryValidateAction |
    ITrialInstitutionItemTemplateCategoryValidateSuccessAction |
    ITrialInstitutionItemTemplateCategoryValidateFailureAction |
    ITrialInstitutionItemTemplateCategoryClearAction |
    ITrialInstitutionItemTemplateCategoryFilterAction;
